
<div class="text-center">
    <img src="../../../assets/logo.png" alt="img-logo" style=" min-width: 200px;" class="rounded mx-auto d-block w-25 mt-5 mb-5" />
</div>